// src/com/tsr/TransPlanTsrEditorGroup.js
import React, { useEffect, useState } from 'react';
import { Button, DialogContent, DialogActions, AppBar, Tabs, Tab, Slide, Dialog } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { AppStyle, TopCode } from '../../value/AppConst';
import TransPlanTsrEditDetail from './TransPlanTsrEditDetail';
// import TransPlanTsrEditSupplyGen982 from './TransPlanTsrEditSupplyGen982';
import TransPlanTsrEditSupplyGeneral from './TransPlanTsrEditSupplyGeneral';
import TransPlanTsrEditSupplyFresh from './TransPlanTsrEditSupplyFresh';
import TransPlanTsrEditSupplyExpress from './TransPlanTsrEditSupplyExpress';
//import TransPlanTsrEditBulkDetail from './TransPlanTsrEditBulkDetail';
import { DialogHeader } from '../../common/TopStyle';


export const TabCodeForTsrEditorGroup = {
    DetailEditor: 1,
    SupplyEditor: 2,
    // BulkEditor: 3,
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * 3종류의 편집기를 Tab으로 구성한 편집기 그룹
 * 1. 상차 상세 내역
 * 2. 물류 집기 - 상온, 냉장, Express 각각 서로 다른 구성.
 * 3. Bulk 상차 상세내역 (특정 DC만 사용)
 * 저장, 취소 버튼은 이 컴포넌트에서 처리. (자식 컴포넌트에서는 변경사항만 보냄)
 * @param {*} param0 
 */
export default function TransPlanTsrEditorGroup({
    open,
    item,
    // tabSelected,
    onClose,
    onRequestSave,
}) {
    const [tabNow, setTabNow] = useState(TabCodeForTsrEditorGroup.DetailEditor);
    const [data, setData] = useState({}); // child에서 변경함.
    const [errorMap, setErrorMap] = useState({});
    const [changed, setChanged] = useState(false); // if setData is called, set true
    const [hasError, setHasError] = useState(false);

    useEffect(()=>{
        if(open && item) {
            const newData = {...item};
            // value={data.pros_dptr_time?data.pros_dptr_time.substring(2,4):data.dptr_req_time.substring(2,4)}
            if(!newData.prosDptrTime) newData.prosDptrTime = newData.dptrReqTime;
            // value={data.pros_arr_time?data.pros_arr_time.substring(0,2):data.arr_req_time.substring(0,2)}
            if(!newData.prosArrTime) newData.prosArrTime = newData.arrReqTime;
            setData(newData);
            setChanged(false);
            setErrorMap({});
            setHasError(false);
        }
    }, [open, item]);

    /* useEffect(()=>{
        if(open && Object.values(TabCodeForTsrEditorGroup).includes(tabSelected)) {
            setTabNow(tabSelected);
        }
    }, [open, tabSelected]); */

    const onChangeData = (id, value, error) => {
        const newData = {...data, [id]: value};
        setErrorMap({...errorMap, [id]: error}); // error is boolean
        setHasError(Object.values(errorMap).some(v => v));
        setChanged(true);
        setData(newData);
    };

    const askCancel = async () => {
        const confirm = window.confirm("변경사항을 무시하고 작업을 종료하시겠습니까?");
        if(confirm) onClose();
    };

    const onClickCancel = () => {
        if(changed) askCancel();
        else onClose();
    };

    const renderByTab = () => {
        if(tabNow===TabCodeForTsrEditorGroup.SupplyEditor) {
            /* if(item.dcCd===TopCode.DcCode.Adc982) {
                return <TransPlanTsrEditSupplyGen982 item={data} onChangeValue={onChangeData} />;
            } */
            if(item.dcTypeCd===TopCode.DcTypeCode.Fresh) {
                return <TransPlanTsrEditSupplyFresh item={data} onChangeValue={onChangeData} />;
            }
            if(item.dcTypeCd===TopCode.DcTypeCode.Express) {
                return <TransPlanTsrEditSupplyExpress item={data} onChangeValue={onChangeData} />;
            }
            return <TransPlanTsrEditSupplyGeneral item={data} onChangeValue={onChangeData} />;
        }
        /* if(tabNow===TabCodeForTsrEditorGroup.BulkEditor) {
            return <TransPlanTsrEditBulkDetail item={data} onChangeValue={onChangeData} />;
        } */
        // default 상차 상세내역
        return <TransPlanTsrEditDetail item={data} onChangeValue={onChangeData} />;
    };

    const onClickSave = () => {
        if(window.confirm("입력한 상차 상세내역 및 물류집기 항목을 저장하고 TSR 저장하시겠습니까?")) {
            if(item.reqTypeCd !== TopCode.ReqStateFlag.NewRequest) {
                alert("저장 후 TSR 재발행 해주세요. TSR발행후에 실적에 반영됩니다.");
            }
            const newData = {
                planId: item.planId,
                // Detail part
                bol1: data.bol1,
                bol2: data.bol2,
                bol3: data.bol3,
                loadCount: data.loadCount,
                loadStTime: data.loadStTime,
                loadEnTime: data.loadEnTime,
                prosDptrTime: data.prosDptrTime,
                prosArrTime: data.prosArrTime,
                sealNo1: data.sealNo1,
                sealNo2: data.sealNo2,
                sealNo3: data.sealNo3,
                loadStaffName: data.loadStaffName,
                unsoldBol: data.unsoldBol,
                unsoldPallet: data.unsoldPallet,
                unsoldCount: data.unsoldCount,
                memo: data.memo,
                // Supply part(상온)
                aPalKpp: data.aPalKpp,
                aPalAju: data.aPalAju,
                aRollN: data.aRollN,
                aRollJum: data.aRollJum,
                aB2bKpp: data.aB2bKpp,
                aB2bAju: data.aB2bAju,
                aEtc: data.aEtc,
                aOpSpec: data.aOpSpec,
                aOpJum: data.aOpJum,
                aOpTrunc: data.aOpTrunc,
                aHiDanpra: data.aHiDanpra,
                aHiRoll: data.aHiRoll,
                aTray: data.aTray,
                bulkItemList: data.bulkItemList, // list. (982 only)
                // fresh
                tempF: data.tempF,
                fFPalKpp: data.fFPalKpp,
                fFPalAju: data.fFPalAju,
                fFShrFull: data.fFShrFull,
                fFShrHalf: data.fFShrHalf,
                fFEtcKpp: data.fFEtcKpp,
                fFEtcAju: data.fFEtcAju,
                tempM: data.tempM,
                fMPalKpp: data.fMPalKpp,
                fMPalAju: data.fMPalAju,
                fMShrFull: data.fMShrFull,
                fMShrHalf: data.fMShrHalf,
                fMEtcKpp: data.fMEtcKpp,
                fMEtcAju: data.fMEtcAju,
                tempR: data.tempR,
                fRPalKpp: data.fRPalKpp,
                fRPalAju: data.fRPalAju,
                fRShrFull: data.fRShrFull,
                fRShrHalf: data.fRShrHalf,
                fREtcKpp: data.fREtcKpp,
                fREtcAju: data.fREtcAju,
                fNjc: data.fNjc,
                fUcolor: data.fUcolor,
                fOctagon: data.fOctagon,
                fTray: data.fTray,
                // express
                //tempF: detailSaved.data.tempF,
                eFDolly: data.eFDolly,
                eFDollycart: data.eFDollycart,
                eFRoll: data.eFRoll,
                eFPalKpp: data.eFPalKpp,
                eFPalAju: data.eFPalAju,
                //tempM: detailSaved.data.tempM,
                eMDolly: data.eMDolly,
                eMDollycart: data.eMDollycart,
                eMRoll: data.eMRoll,
                eMPalKpp: data.eMPalKpp,
                eMPalAju: data.eMPalAju,
                //tempR: detailSaved.data.tempR,
                eRDolly: data.eRDolly,
                eRDollycart: data.eRDollycart,
                eRRoll: data.eRRoll,
                eRPalKpp: data.eRPalKpp,
                eRPalAju: data.eRPalAju,
                eCigar: data.eCigar,
                eCorn: data.eCorn,
                ePulp: data.ePulp,
                eMu: data.eMu,
                eJumDolly: data.eJumDolly,
                eJumDollycart: data.eJumDollycart,
                eJumRoll: data.eJumRoll,
            };
            onRequestSave(newData);
        }
    };

    if(!open || !item) return null;

    return(
        <Dialog
            fullScreen
            open={open}
            onClose={onClose}
            slots={{transition: Transition}}
        >
            <DialogHeader
                title="TSR 발행 상세 조회"
                onClickClose={onClickCancel}
            />
            <DialogContent style={{paddingTop: '0.5rem', }}>
                {renderByTab()}
            </DialogContent>
            <DialogActions>
                        <Button
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                            startIcon={<CloudUploadIcon />}
                            disabled={!changed || hasError}
                            onClick={onClickSave}
                            style={{height: '100%'}}
                        >
                            저장
                        </Button>
            </DialogActions>
            <DialogActions>
                        <AppBar position="static" color="default" style={{borderTop: '1px solid #ddd'}}
                        >
                            <Tabs value={tabNow} onChange={(e, v)=>setTabNow(v)}>
                                <Tab value={TabCodeForTsrEditorGroup.DetailEditor} label="상차 상세내역" />
                                <Tab value={TabCodeForTsrEditorGroup.SupplyEditor} label="물류 집기" />
                                {/*
                                    item.dcCd===TopCode.DcCode.Adc982 &&
                                    <Tab value={TabCodeForTsrEditorGroup.BulkEditor} label="Bulk 상차 상세내역" />*/
                                }
                            </Tabs>
                        </AppBar>
            </DialogActions>
        </Dialog>
    );
}
